import packageJson from '../../package.json';

export type WebBuildMetadata = {
  version: string;
  commit: string;
  builtAt: string | null;
  repository: string;
  branch: string;
  commitUrl: string | null;
  ciRunUrl: string | null;
  changelogUrl: string | null;
};

export const fallbackWebBuildMetadata: WebBuildMetadata = {
  version: packageJson.version,
  commit: process.env.REACT_APP_GIT_COMMIT || 'local',
  builtAt: process.env.REACT_APP_BUILT_AT || null,
  repository: process.env.REACT_APP_BUILD_REPO || 'Etappio-AB/etappio-web',
  branch: process.env.REACT_APP_BUILD_BRANCH || 'local',
  commitUrl: null,
  ciRunUrl: null,
  changelogUrl: '/changelog'
};

let metadataRequest: Promise<WebBuildMetadata> | null = null;

export function getWebBuildMetadata(): Promise<WebBuildMetadata> {
  metadataRequest ??= fetch('/build-metadata.json', { cache: 'no-store' })
    .then(async response => {
      if (!response.ok) throw new Error(`Build metadata returned ${response.status}`);
      const payload = await response.json() as Partial<WebBuildMetadata>;
      if (!payload.version || !payload.commit) {
        throw new Error('Build metadata is incomplete');
      }
      return {
        ...fallbackWebBuildMetadata,
        ...payload
      };
    })
    .catch(() => fallbackWebBuildMetadata);

  return metadataRequest;
}

export function resetWebBuildMetadataCacheForTests() {
  metadataRequest = null;
}
